import React, { FC, PropsWithChildren, ReactNode } from 'react';
import cx from 'classnames';
import { PropsWithClassName } from '@/types/common';
import * as styles from './TitleBodyGroup.module.scss';

type Props = PropsWithChildren<
  PropsWithClassName<{
    title: ReactNode;
  }>
>;

const TitleBodyGroup: FC<Props> = ({ className, title, children }) => (
  <div className={cx(styles.main, className)}>
    <div className={styles.title}>{title}</div>
    <div className={styles.body}>{children}</div>
  </div>
);

export default TitleBodyGroup;
